import {
  isPxClient,
  isRpClient,
  isSureClient,
  isTrustClient,
} from '@core/constants/program-code-constants';

export type NgClassObj = { [key: string]: boolean };
export const clientClassObj = (programCode: string) => {
  return (
    [
      { name: 'sp', check: isSureClient },
      { name: 'pxgo', check: isPxClient },
      { name: 'sunt', check: isTrustClient },
      { name: 'rp', check: isRpClient },
    ]
      .filter(({ check }) => check(programCode))
      .map(({ name }) => ({ [name]: true }))
      .shift() ?? {}
  );
};
